'use client'; // Error components must be Client Components
import { useIntl } from '@capsicum/common';
import styled from 'styled-components';

import { AndroidArrowChromeMenuIcon, AndroidDownloadAppIcon, AndroidThreeDotsIcon } from '../../icons';

import Step from './parts/Step';
import { BaseTopContent, BaseWrapper, Title } from './Shared.styles';
import { SkipPWA } from './SkipPWA';

export const AndroidDeviceCTA = () => {
	const { $t } = useIntl();

	return (
		<S.Wrapper>
			<div>
				<S.TopContent>
					<S.Content>
						<Title>{$t('pwa.instructions.android.title')}</Title>
						<div>{$t('pwa.instructions.android.description')}</div>
					</S.Content>
				</S.TopContent>
				<S.Steps>
					<Step
						content={$t('pwa.instructions.android.step1')}
						Icon={AndroidThreeDotsIcon}
						title={$t('pwa.instructions.step_number', { number: '1' })}
						variant="android"
					/>
					<Step
						content={$t('pwa.instructions.android.step2')}
						Icon={AndroidDownloadAppIcon}
						title={$t('pwa.instructions.step_number', { number: '2' })}
						variant="android"
					/>
				</S.Steps>
				<S.Arrow />
			</div>
			<SkipPWA />
		</S.Wrapper>
	);
};

namespace S {
	export const Wrapper = styled(BaseWrapper)`
		align-items: center;
		gap: ${({ theme }) => theme.spacings.medium};
		justify-content: space-between;
		padding-bottom: ${({ theme }) => theme.spacings.xlarge};
	`;
	export const TopContent = styled(BaseTopContent)`
		padding: ${({ theme }) => `${theme.spacings.xxlarge} ${theme.spacings.small} 0`};
		flex-direction: row;
		align-items: flex-start;
	`;
	export const Content = styled.div`
		display: flex;
		padding-left: ${({ theme }) => theme.spacings.small};
		flex-direction: column;
		justify-content: center;
		align-items: center;
		gap: ${({ theme }) => theme.spacings.xxsmall};
		align-self: stretch;
		text-align: left;
		width: 50%;
	`;
	export const Steps = styled.div`
		display: flex;
		padding: ${({ theme }) => `0 ${theme.spacings.small}`};
		flex-direction: column;
		align-items: flex-end;
	`;
	export const Arrow = styled(AndroidArrowChromeMenuIcon)`
		position: absolute;
		top: ${({ theme }) => theme.spacings.small};
		right: ${({ theme }) => theme.spacings.small};
	`;
}
